<template>
  <div>
    <v-container class="py-0 text-center">
      <h1 v-if="!cadavers" class="mx-auto my-0">Loading Cadaver Data...</h1>
      <h1 v-if="cadavers" class="mx-auto my-0">
        Loaded {{ Object.keys(cadavers).length }} Cadavers
      </h1>
    </v-container>
    <v-container v-if="cadavers">
      <h1 class="display-2">View Cadaver</h1>
      <cadaverViewer :cadavers="cadavers"></cadaverViewer>
      <h1 class="display-2">Find Student</h1>
      <findStudent :cadavers="cadavers" :students="students"></findStudent>
      <h1 class="display-2">Export Data</h1>
      <exportData
        :cadavers="cadavers"
        :students="students"
        :cadaverOid="cadaverOid"
      ></exportData>
    </v-container>
    <v-snackbar v-model="timeout" class="text-center" top :timeout="-1">
      ⚠️ ข้อมูลอาจเก่าแล้ว กรุณา Refresh หน้านี้
    </v-snackbar>
  </div>
</template>

<script>
/// <reference path="../../types/cadavers.d.ts" />
import cadaverViewer from "./cadaverViewer";
import findStudent from "./findStudent";
import exportData from "./exportData";
import { apiFetch } from "../../api";

export default {
  name: "Admin",
  components: { cadaverViewer, findStudent, exportData },
  props: ["email"],
  data: () => ({
    cadavers: null,
    students: null,
    cadaverOid: null,
    timeout: false
  }),
  watch: {
    email: {
      handler(email) {
        if (email) {
          apiFetch("admin")
            .then(res => res.json())
            .then(json => {
              this.cadavers = json.cadavers.data;
              this.students = json.students.data;
              this.cadaverOid = json.cadavers.meta.abbreviatedOid;
              this.dataTimeout = setTimeout(() => {
                this.timeout = true;
              }, 4 * 60 * 1000); // 6 mins
            });
        }
      },
      immediate: true
    }
  },
  mounted() {
    /* global amplitude */
    amplitude.getInstance().logEvent("view_admin");
  },
  beforeDestroy() {
    clearTimeout(this.dataTimeout);
  }
};
</script>
